import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getImpactCalculateVenueCo2ForProject } from './get-impact-calculate-venue-co2-for-project.action';

type Params = {
  projectId: number;
  dateId: number;
};

type Result = void;

export const runImpactCalculateVenueCo2ForDate = createAppAsyncThunk(
  'impactCalculateVenue/runImpactCalculateVenueCo2ForDate',
  async (
    { projectId, dateId }: Params,
    { extra: { impactCalculateVenueGateway, snackbarGateway }, dispatch },
  ): Promise<Result> => {
    try {
      const modelEnvVersion = 'ENV_SEASON_EVENT';
      await impactCalculateVenueGateway.runImpactCalculateVenueCo2ForDate(
        dateId,
        projectId,
        modelEnvVersion,
      );
      dispatch(getImpactCalculateVenueCo2ForProject({ projectId }));
      setTimeout(
        () => dispatch(getImpactCalculateVenueCo2ForProject({ projectId })),
        2000,
      );
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
